import * as tslib_1 from "tslib";
import { formApi } from "../../../../../api";
import H3Textarea from "../../../../../form/src/common/components/h3-textarea.vue";
import MutilText from "../../../../../form/src/common/components/mutil-text.vue";
import { TextInputControl } from "../../../../../form/src/common/controls/input-controls/text-input-control";
import { Input, Tooltip } from "@h3/antd-vue";
import { Component } from "vue-property-decorator";
let PcInputText = class PcInputText extends TextInputControl {
    constructor() {
        super(...arguments);
        this.showTip = '';
        this.focus = false;
        this.timer = null;
        // 是否启用数据字典
        this.isUseDataDictionary = false;
        this.dictionaryId = '';
        this.inputId = +new Date() + '';
        this.dictionaryData = []; // 数据字典数据
        this.useDictionariesData = [];
        this.isUseCheckData = false; // 是否仅使用配置的字典数据，否则使用全字典最新数据
        this.searchResWidth = '0';
        this.searchResLeft = '0';
        this.searchResTop = '0';
    }
    onKeydown(evt) {
        const key = evt.key.toLowerCase();
        if (key !== "delete" && key !== "backspace") {
            if (this.ctrl.value && this.ctrl.value.length > this.maxLength) {
                evt.preventDefault();
            }
        }
    }
    onKeyup() {
        if (this.ctrl.value && this.ctrl.value.length > this.maxLength) {
            const val = this.ctrl.value.substr(0, this.maxLength);
            this.setValue(val);
        }
    }
    onBlur() {
        super.validate();
        setTimeout(() => {
            this.focus = false;
        }, 300);
    }
    onFocus() {
        this.focus = true;
        this.getDictionaryData();
    }
    onChange() {
        if (this.dictionaryId) {
            this.getDictionaryData();
        }
        const val = this.val.length === 0 ? null : this.val;
        if (this.val.length > this.maxLength) {
            this.showTip = this.control.options && this.control.options.maxLengthTips ? this.control.options.maxLengthTips : '';
            if (this.showTip) {
                if (this.timer)
                    clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.showTip = '';
                }, 3000);
            }
        }
        this.setValue(val);
    }
    getElementPosition(e) {
        var offset = e.getBoundingClientRect();
        return offset;
    }
    get isShowSearch() {
        if (this.$refs['inputWrapper' + this.inputId]) {
            this.searchResLeft = this.getElementPosition(this.$refs['inputWrapper' + this.inputId]).x + 'px';
            this.searchResTop = this.getElementPosition(this.$refs['inputWrapper' + this.inputId]).y + 32 + 'px';
            // @ts-ignore
            this.searchResWidth = this.$refs['inputWrapper' + this.inputId].clientWidth + 'px';
        }
        return this.focus && this.filterDictionaryDataList.length && this.val !== '';
    }
    get filterDictionaryDataList() {
        if (this.val === '') {
            return this.dictionaryData;
        }
        return this.dictionaryData.filter((el) => !!~el.name.indexOf(this.val));
    }
    getDictionaryData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isUseCheckData) {
                return;
            }
            let res = yield formApi.getEnableRecordsByDictionaryId({
                dicId: this.dictionaryId,
            });
            if (res.errcode === 0) {
                this.dictionaryData = res.data;
            }
        });
    }
    checkData(name) {
        this.val = name;
        this.setValue(name);
    }
    created() {
        try {
            this.control.options.dictionaryData = JSON.parse(this.control.options.dictionaryData).dictionaryData;
        }
        catch (error) {
        }
        if (this.control.options && this.control.options.dictionaryData && this.control.options.dictionaryData.isUseDataDictionary) {
            this.isUseDataDictionary = true;
            try {
                let options = {};
                if (typeof this.control.options.dictionaryData.options.value === 'string') {
                    options = JSON.parse(this.control.options.dictionaryData.options.value);
                }
                else {
                    options = this.control.options.dictionaryData.options.value;
                }
                console.log('111=>>', options);
                this.dictionaryId = options.checkedDictionary || '';
                this.useDictionariesData = options.useDictionariesData;
                this.dictionaryData = options.useDictionariesData;
                if (options.useDictionariesData.length) {
                    this.isUseCheckData = true;
                }
            }
            catch (error) {
                console.log('666===>', error);
            }
        }
    }
    mounted() {
        // @ts-ignore
        this.searchResWidth = this.$refs['inputWrapper' + this.inputId].clientWidth + 'px';
    }
};
PcInputText = tslib_1.__decorate([
    Component({
        name: "pc-input-text",
        components: {
            AInput: Input,
            ATooltip: Tooltip,
            // ATextarea: Input.TextArea,
            H3Textarea,
            MutilText
        }
    })
], PcInputText);
export default PcInputText;
